import { tasksEnTranslations } from './tasks.en';
import { tasksHeTranslations } from './tasks.he';

export const tasksTranslations = {
  en: tasksEnTranslations,
  he: tasksHeTranslations,
} as const;
